import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4125d5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = {
  class: "form fv-plugins-bootstrap5 fv-plugins-framework",
  style: {"max-height":"90vh","overflow":"scroll"}
}
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold" }, "Check Rebate Setting", -1))
const _hoisted_5 = {
  class: "btn btn-icon btn-sm btn-active-icon-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "p-7"
}
const _hoisted_9 = {
  key: 0,
  class: "d-flex flex-end mb-5"
}
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "accountTypeHead" }, null, -1))
const _hoisted_12 = { class: "ms-5 mt-3" }
const _hoisted_13 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa-solid fa-circle me-2 mt-1",
    style: {"color":"#900000"}
  }),
  /*#__PURE__*/_createTextVNode("一級代理的 Rate 不符合设置 (請更新正確數值) ")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "說明：此一級代理的 Rate 總合與配置不同", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa-solid fa-circle me-2 mt-1",
    style: {"color":"#900000"}
  }),
  /*#__PURE__*/_createTextVNode("一級代理的 Pip 組合與設置不符 (特殊設置請通知 IT) ")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "說明：此一級代理的 Pip 組合有數值不在配置內", -1))
const _hoisted_20 = {
  key: 2,
  class: "mb-3"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa-solid fa-circle me-2 mt-1",
    style: {"color":"#900000"}
  }),
  /*#__PURE__*/_createTextVNode("一級代理的 Commission 組合與設置不符 ")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "說明：此一級代理的 Commission 組合有數值不在配置內", -1))
const _hoisted_23 = {
  key: 3,
  class: "mb-3"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa-solid fa-circle me-2 mt-1",
    style: {"color":"#900000"}
  }),
  /*#__PURE__*/_createTextVNode("代理的 Pip 數值不在一級代理的組合內 ")
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "說明：一級代理沒有開此加點的權限", -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = {
  key: 4,
  class: "mb-3"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa-solid fa-circle me-2 mt-1",
    style: {"color":"#900000"}
  }),
  /*#__PURE__*/_createTextVNode("代理的 Commission 數值不在一級代理的組合內 ")
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "說明：一級代理沒有開此加佣的權限", -1))
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = {
  key: 5,
  class: "mb-3"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa-solid fa-circle me-2 mt-1",
    style: {"color":"#900000"}
  }),
  /*#__PURE__*/_createTextVNode("銷售沒有允許代理設置 Pip ( 清除代理加點 ) ")
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "說明：銷售沒有給這個帳戶類型開放加點權限", -1))
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = {
  key: 6,
  class: "mb-3"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa-solid fa-circle me-2 mt-1",
    style: {"color":"#900000"}
  }),
  /*#__PURE__*/_createTextVNode("銷售沒有允許代理設置 Commission ( 清除代理加佣 ) ")
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "說明：銷售沒有給這個帳戶類型開放加佣權限", -1))
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = { key: 7 }
const _hoisted_40 = { key: 2 }
const _hoisted_41 = {
  key: 0,
  class: "d-flex p-7"
}

import { ref } from "vue";
import { showModal, hideModal } from "@/core/helpers/dom";
import RebateService from "../../../rebate/services/RebateService";
import VueJsonView from "@matpool/vue-json-view";


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckRebateSetting',
  emits: ["updateCheckingStatus", "buildRelationForm"],
  setup(__props, { expose: __expose, emit }) {



const relationList = ref([]);
const rebateInfo = ref({});
const originalRebateInfo = ref({});
const defaultRebateRate = ref({});
const topAgentLevelSetting = ref({} as any);
const ErrorMessages = ref({} as any);
const checkRebateSettingRef = ref<null | HTMLElement>(null);
const isChecking = ref(true);
const ITView = ref(false);
const checkHasError = ref(false);
const updatedNeedReLoad = ref(false);
const autoUpdateItem = ref([] as any);
const topAgentAccountTypes = ref([] as any);

const checkingTypes = {
  isChecking: 0,
  passed: 1,
  failed: 2,
  noNeed: 3,
};

const pcOption = ref({
  pip: "pip",
  commission: "commission",
});

const hide = () => {
  hideModal(checkRebateSettingRef.value);
};

const updateTopAgentRule = (_accountUid, _accountType) => {
  if (!_accountUid) {
    return Promise.resolve();
  }

  const requestObject =
    rebateInfo.value[_accountUid]?.levelSetting.allowedAccounts[_accountType];

  return RebateService.updateTopAgentRule(
    rebateInfo.value[_accountUid].id,
    JSON.parse(JSON.stringify(requestObject))
  )
    .then(() => {
      updatedNeedReLoad.value = true;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const updateAgentRule = (_accountUid, _accountType) => {
  if (!rebateInfo.value[_accountUid]?.schema[_accountType]) {
    return Promise.resolve();
  }

  let requestObject = rebateInfo.value[_accountUid]?.schema[_accountType];
  requestObject.accountType = _accountType;

  return RebateService.updateAgentRule(
    rebateInfo.value[_accountUid].id,
    JSON.parse(JSON.stringify(requestObject))
  )
    .then(() => {
      updatedNeedReLoad.value = true;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const checkPipCommissionOptions = (
  accountType,
  key,
  defaultOptions,
  currentOptions
) => {
  if (
    defaultOptions.length === 0 &&
    currentOptions.length === 1 &&
    currentOptions[0] === 0
  ) {
    autoUpdateItem.value.push({
      key: key,
      accountType: accountType,
      defaultOption: defaultOptions,
      oldOption: currentOptions,
      newOption: [],
    });
    currentOptions = [];
  } else if (!currentOptions.every((val) => defaultOptions.includes(val))) {
    if (key == pcOption.value.pip) {
      ErrorMessages.value[accountType].allowPipOptionsError = true;
      ErrorMessages.value[accountType].allowPipOptions = defaultOptions;
      ErrorMessages.value[accountType].currentPipOptions = currentOptions;
      checkHasError.value = true;
    }
    if (key == pcOption.value.commission) {
      ErrorMessages.value[accountType].allowCommissionOptionsError = true;
      ErrorMessages.value[accountType].allowCommissionOptions = defaultOptions;
      ErrorMessages.value[accountType].currentCommissionOptions =
        currentOptions;
      checkHasError.value = true;
    }
  }

  return currentOptions;
};

const checkTopAgentLevelSetting = async () => {
  topAgentLevelSetting.value = (
    Object.values(rebateInfo.value).find((acc: any) => acc.isRoot) as any
  )?.levelSetting.allowedAccounts;

  topAgentAccountTypes.value = Object.keys(topAgentLevelSetting.value);

  // Loop Available Account Types
  topAgentAccountTypes.value.forEach((accountType: any) => {
    // Loop Default Rebate Rate
    var match = true;
    for (let op = 0; op < defaultRebateRate.value[accountType].length; op++) {
      const defaultOption = defaultRebateRate.value[accountType][op];
      const defaultSettingItems = defaultOption.category;
      ErrorMessages.value[accountType] = {};
      match = true;

      // Loop Top Agent Level Setting to check if it matches with Default
      for (
        let index = 0;
        index < topAgentLevelSetting.value[accountType].items.length;
        index++
      ) {
        const item = topAgentLevelSetting.value[accountType].items[index];
        if (defaultSettingItems[item.cid] !== item.r) {
          match = false;
          break;
        }
      }

      //auto update
      topAgentLevelSetting.value[accountType].pips = null;
      topAgentLevelSetting.value[accountType].commission = null;
      topAgentLevelSetting.value[accountType].percentage = 0;

      if (match) {
        autoUpdateItem.value.push({
          accountType: accountType,
          oldName: topAgentLevelSetting.value[accountType].optionName,
          matchName: defaultOption.optionName,
        });
        //Update Default
        topAgentLevelSetting.value[accountType].optionName =
          defaultOption.optionName;

        // Check allowPipOptions
        topAgentLevelSetting.value[accountType].allowPips =
          checkPipCommissionOptions(
            accountType,
            pcOption.value.pip,
            defaultOption.allowPipOptions,
            topAgentLevelSetting.value[accountType].allowPips
          );
        topAgentLevelSetting.value[accountType].allowCommissions =
          checkPipCommissionOptions(
            accountType,
            pcOption.value.commission,
            defaultOption.allowCommissionOptions,
            topAgentLevelSetting.value[accountType].allowCommissions
          );
        break;
      }
    }
    if (!match) {
      ErrorMessages.value[accountType].rateNotMatchDefaultSetting = true;
      checkHasError.value = true;
    }
  });
};

const checkAgentSchema = async () => {
  // Loop Agent Rules (except top agent)
  for (let uid in rebateInfo.value) {
    if (!rebateInfo.value[uid].isRoot) {
      const schema = rebateInfo.value[uid].schema;
      for (const accountType of topAgentAccountTypes.value) {
        if (!schema[accountType]) {
          continue;
        }
        // Auto Fix
        autoUpdateItem.value.push({
          accountType: accountType,
          oldName: schema[accountType].optionName,
          matchName: topAgentLevelSetting.value[accountType].optionName,
        });

        schema[accountType].optionName =
          topAgentLevelSetting.value[accountType].optionName;

        // Auto Fix
        if (schema[accountType].pips > 0) {
          if (schema[accountType].commission == 0) {
            autoUpdateItem.value.push({
              uid: uid,
              accountType: accountType,
              old: [schema[accountType].pips, schema[accountType].commission],
              new: [schema[accountType].pips, null],
            });
            schema[accountType].commission = null;
          }
        }

        // Auto Fix
        if (schema[accountType].commission > 0) {
          if (schema[accountType].pips == 0) {
            autoUpdateItem.value.push({
              uid: uid,
              accountType: accountType,
              old: [schema[accountType].pips, schema[accountType].commission],
              new: [null, schema[accountType].commission],
            });
            schema[accountType].pips = null;
          }
        }

        // Auto Fix
        if (
          schema[accountType].pips == 0 &&
          schema[accountType].commission == 0
        ) {
          if (topAgentLevelSetting.value[accountType].allowPips.includes(0)) {
            autoUpdateItem.value.push({
              uid: uid,
              accountType: accountType,
              allowPips: topAgentLevelSetting.value[accountType].allowPips,
              allowCommissions:
                topAgentLevelSetting.value[accountType].allowCommissions,
              old: [schema[accountType].pips, schema[accountType].commission],
              new: [schema[accountType].pips, null],
            });
            schema[accountType].commission = null;
          } else if (
            topAgentLevelSetting.value[accountType].allowCommissions.includes(0)
          ) {
            autoUpdateItem.value.push({
              uid: uid,
              accountType: accountType,
              allowPips: topAgentLevelSetting.value[accountType].allowPips,
              allowCommissions:
                topAgentLevelSetting.value[accountType].allowCommissions,
              old: [schema[accountType].pips, schema[accountType].commission],
              new: [null, schema[accountType].commission],
            });
            schema[accountType].pips = null;
          } else {
            autoUpdateItem.value.push({
              uid: uid,
              accountType: accountType,
              allowPips: topAgentLevelSetting.value[accountType].allowPips,
              allowCommissions:
                topAgentLevelSetting.value[accountType].allowCommissions,
              old: [schema[accountType].pips, schema[accountType].commission],
              new: [null, null],
            });
            schema[accountType].pips = null;
            schema[accountType].commission = null;
          }
        }

        // Manual Fix
        if (topAgentLevelSetting.value[accountType].allowPips.length == 0) {
          // auto update
          if (schema[accountType].pips == 0) {
            autoUpdateItem.value.push({
              uid: uid,
              accountType: accountType,
              allowPips: topAgentLevelSetting.value[accountType].allowPips,
              allowCommissions:
                topAgentLevelSetting.value[accountType].allowCommissions,
              old: [schema[accountType].pips, schema[accountType].commission],
              new: [null, schema[accountType].commission],
            });
            schema[accountType].pips = null;
          } else if (schema[accountType].pips != null) {
            ErrorMessages.value[accountType].noPipAllowError = true;
            checkHasError.value = true;
          }
        } else {
          if (
            schema[accountType].pips != null &&
            !topAgentLevelSetting.value[accountType].allowPips.includes(
              schema[accountType].pips
            )
          ) {
            ErrorMessages.value[accountType].PipValueError = true;
            checkHasError.value = true;
          }
        }

        // Manual Fix
        if (
          topAgentLevelSetting.value[accountType].allowCommissions.length == 0
        ) {
          if (schema[accountType].commission == 0) {
            autoUpdateItem.value.push({
              uid: uid,
              accountType: accountType,
              allowPips: topAgentLevelSetting.value[accountType].allowPips,
              allowCommissions:
                topAgentLevelSetting.value[accountType].allowCommissions,
              old: [schema[accountType].pips, schema[accountType].commission],
              new: [schema[accountType].pips, null],
            });
            schema[accountType].commission = null;
          } else if (schema[accountType].commission != null) {
            ErrorMessages.value[accountType].noCommissionAllowError = true;
            checkHasError.value = true;
          }
        } else {
          if (
            schema[accountType].commission != null &&
            !topAgentLevelSetting.value[accountType].allowCommissions.includes(
              schema[accountType].commission
            )
          ) {
            ErrorMessages.value[accountType].CommissionValueError = true;
            checkHasError.value = true;
          }
        }
      }
    }
  }
};

const onCheck = async (_relationList, _rebateInfo, _defaultRebateRate) => {
  rebateInfo.value = _rebateInfo;
  relationList.value = _relationList;
  defaultRebateRate.value = _defaultRebateRate;
  originalRebateInfo.value = JSON.parse(JSON.stringify(_rebateInfo));

  isChecking.value = true;
  checkHasError.value = false;
  updatedNeedReLoad.value = false;

  ErrorMessages.value = {};
  autoUpdateItem.value = [];

  await checkTopAgentLevelSetting();
  await checkAgentSchema();
  await updateAgentRebateRule();

  if (updatedNeedReLoad.value) {
    console.log(autoUpdateItem.value);
    emit("buildRelationForm");
    return;
  }

  isChecking.value = false;

  if (checkHasError.value) {
    emit("updateCheckingStatus", checkingTypes.failed);
  } else {
    emit("updateCheckingStatus", checkingTypes.passed);
  }
};

const updateAgentRebateRule = async () => {
  const promises = [];
  const existPromise = [];

  for (const accountType of topAgentAccountTypes.value) {
    for (const uid of Object.keys(rebateInfo.value)) {
      if (
        originalRebateInfo.value[uid].levelSetting.allowedAccounts[
          accountType
        ] == undefined
      ) {
        continue;
      }
      if (
        rebateInfo.value[uid].isRoot &&
        JSON.stringify(
          originalRebateInfo.value[uid].levelSetting.allowedAccounts[
            accountType
          ]
        ) !==
          JSON.stringify(
            rebateInfo.value[uid].levelSetting.allowedAccounts[accountType]
          )
      ) {
        if (existPromise.includes(uid)) {
          await updateTopAgentRule(uid, accountType);
        } else {
          existPromise.push(uid);
          promises.push(() => updateTopAgentRule(uid, accountType));
        }
      } else if (
        JSON.stringify(originalRebateInfo.value[uid].schema[accountType]) !==
        JSON.stringify(rebateInfo.value[uid].schema[accountType])
      ) {
        if (existPromise.includes(uid)) {
          await updateAgentRule(uid, accountType);
        } else {
          existPromise.push(uid);
          promises.push(() => updateAgentRule(uid, accountType));
        }
      }
    }
  }

  await Promise.all(promises.map((func) => func()));
};

const show = async () => {
  showModal(checkRebateSettingRef.value);
};

__expose({
  show,
  onCheck,
});

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: "kt_modal_check_rebate",
    tabindex: "-1",
    "aria-hidden": "true",
    ref_key: "checkRebateSettingRef",
    ref: checkRebateSettingRef
  }, [
    _createElementVNode("div", {
      style: {"position":"relative","background-color":"black","opacity":"0.5","width":"100%","height":"100%"},
      onClick: hide
    }),
    _createElementVNode("div", {
      class: _normalizeClass(["modal-dialog modal-dialog-centered", ITView.value ? 'fullWidth' : 'mw-550px']),
      style: {"position":"absolute","top":"0","bottom":"0","right":"0","left":"0"}
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_inline_svg, { src: "/images/icons/arrows/arr061.svg" })
              ])
            ])
          ]),
          (isChecking.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Checking"))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_ctx.$can('SuperAdmin'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_el_button, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (ITView.value = !ITView.value))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("IT Department")
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ErrorMessages.value, (value, key) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: key,
                    class: "mb-5"
                  }, [
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("h4", null, _toDisplayString(_ctx.$t("type.account." + key)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      (value['rateNotMatchDefaultSetting'])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
                        : _createCommentVNode("", true),
                      (value['allowPipOptionsError'])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _hoisted_18,
                            _hoisted_19,
                            _createElementVNode("div", null, "- 可用加佣：" + _toDisplayString(value["allowPipOptions"]), 1),
                            _createElementVNode("div", null, "- 目前設置：" + _toDisplayString(value["currentPipOptions"]), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (value['allowCommissionOptionsError'])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _hoisted_21,
                            _hoisted_22,
                            _createElementVNode("div", null, "- 可用加佣：" + _toDisplayString(value["allowCommissionOptions"]), 1),
                            _createElementVNode("div", null, "- 目前設置：" + _toDisplayString(value["currentCommissionOptions"]), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (value['PipValueError'])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_26))
                        : _createCommentVNode("", true),
                      (value['CommissionValueError'])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_30))
                        : _createCommentVNode("", true),
                      (value['noPipAllowError'])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_34))
                        : _createCommentVNode("", true),
                      (value['noCommissionAllowError'])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_38))
                        : (_openBlock(), _createElementBlock("h5", _hoisted_39))
                    ])
                  ]))
                }), 128))
              ])),
          (_ctx.$can('SuperAdmin'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                (ITView.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rebateInfo.value, (rule, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          _createVNode(_unref(VueJsonView), {
                            src: rule,
                            collapsed: true,
                            theme: "rjv-default"
                          }, null, 8, ["src"])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createBlock(_unref(VueJsonView), {
                      key: 1,
                      src: autoUpdateItem.value,
                      theme: "rjv-default"
                    }, null, 8, ["src"]))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2)
  ], 512))
}
}

})